import React, { Component } from 'react';
import {provideIntlService } from '@progress/kendo-react-intl';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

class GridDateFormatter extends Component {
	constructor(props) {
		super(props);
		this.state = {

		}
	}
	formatDate = (date_string) => {
		var utc = (new Date(Date.parse(date_string))).toLocaleString('en-US', { timeZone: 'Etc/UTC' });
		return (new Date(utc).getMonth() + 1) + "/" + new Date(utc).getDate() + "/" + new Date(utc).getFullYear();
	}
	render() {
		return (
			<td colSpan={this.props.colSpan} style={this.props.style}>
				{
					this.props.dataItem[this.props.field] != null ?
					this.formatDate(this.props.dataItem[this.props.field])
				 :''
				}
			</td>
		);
	}
}
export default withRouter(connect(
)(GridDateFormatter));
